

<template>
  <div>
    <div v-if="rowData.invoice_status === 'Unpaid'" class="custom-actions">
      <button
        class="btn btn-success btn-micro"
        @click="payAction('view-item', rowData, rowIndex)"
      >{{$t('upgrade.payUpgrade')}}</button>
      <button
        class="btn btn-danger btn-micro"
        @click="cancelAction('view-item', rowData, rowIndex)"
      >{{$t('upgrade.cancelUpgrade')}}</button>
    </div>
    <div v-else></div>
    <vuestic-modal
      show.sync="true"
      ref="mediumModal"
      :okText="'modal.confirm' | translate"
      v-on:ok="confirm"
      :cancelText="'modal.cancel' | translate"
    >
      <div slot="title">{{$t('upgrade.deleteUpgrade')}}</div>
      <div>{{$t('upgrade.deleteUpgradeModalBody')}}</div>
    </vuestic-modal>
  </div>
</template>

<script>
import store from '../../store'
import ajax from 'services/ajax'
import configs from 'services/configs'
import iframeUtil from '../../services/iframeUtil';

export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data () {
    return {
      selected: null,
    }
  },
  methods: {
    itemAction (action, data, index) {
      console.log('custom-actions: ' + action, data.name, index)
    },
    payAction (action, data, index) {
      // this.$router.push('/management/' + data.hosting_id)
      this.showToast(this.$t('upgrade.step4Title'), {
        icon: 'fa-star-o',
        position: 'top-center',
        duration: 4000,
        fullWidth: false
      })

      // Redirect to invoice page
      iframeUtil.sendEventToParent('redirect', {
        invoiceId: data.invoice_id,
      })

      var invoiceUrl = configs.CLIENT_AREA() + 'viewinvoice.php?id=' + data.invoice_id
      window.location.replace(invoiceUrl)
    },
    cancelAction (action, data, index) {
      // this.$router.push('/management/' + data.hosting_id)
      this.selected = data
      this.$refs.mediumModal.open()
    },
    confirm () {
      console.log(this.selected)
      store.commit('setLoading', true)
      ajax.run(this, 'customer/upgrades/cancell/' + this.selected.id, (data) => {
        this.showToast(this.$t('upgrade.deleteSuccess'), {
          icon: 'fa-check',
          position: 'top-center',
          duration: 3000,
          fullWidth: false
        })
      }, (error) => {
        this.showToast(this.$t('global_error.internal'), {
          icon: 'fa-exclamation',
          position: 'top-center',
          duration: 3000,
          fullWidth: false
        })
        store.commit('setLoading', false)
      }, 'delete')
    }
  }
}
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/upgrade/ManageAction.vue